import { FetchResult, gql } from 'apollo-boost';
import { ISystem } from '../../../models/system';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query {
        system {
            uid,
            minMobileVersion: min_mobile_version,
            mobileUpdateLink: mobile_update_link,
            mobilePaywallOn: mobile_paywall_on,
            mobilePaymentOptional: mobile_payment_optional,
            paymentOptionalPausePeriod: payment_optional_pause_period,
            numberOfSessionsBeforePaywall: number_of_sessions_before_paywall,
            orgSupportOn: org_support_on
        }
    }
`;

export async function getSystem(): Promise<ISystem> {
    const result: FetchResult<{ system: ISystem }> = await graphqlClient.query({
        query: QUERY,
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.system;
}
